export const CardTemplate = function (body, msTeams) {
  let temp = {
    type: 'message',
    attachments: [
      {
        contentType: 'application/vnd.microsoft.card.adaptive',
        content: {
          $schema: 'http://adaptivecards.io/schemas/adaptive-card.json',
          type: 'AdaptiveCard',
          version: '1.0',

          body: body,
        },
      },
    ],
  };
  if (msTeams) {
    temp['attachments'][0]['content']['msteams'] = {
      width: 'Full',
      entities: msTeams,
    };
  }
  return JSON.stringify(temp);
};

export const BugReportCard = function (payload, appName) {
  const body = [];
  let msteam = [{}];

  const color = payload?.color || 'warning';
  const title = payload?.title;
  const TitleBody = {
    type: 'Container',
    items: [
      {
        type: 'TextBlock',
        text: title,
        weight: 'bolder',
        size: 'Large',
        color: color,
        wrap: true,
      },
    ],
  };
  body.push(TitleBody);

  if (payload.summary) {
    const summaryContent = {
      type: 'TextBlock',
      text: JSON.stringify(payload.summary),
      wrap: true,
    };
    body.push(summaryContent);
  }
  if (payload.metaData) {
    const metaData = payload?.metaData;
    const metaDataContentItems = [{ title: 'App:', value: appName }];
    for (const key in metaData) {
      if (metaData.hasOwnProperty(key)) {
        const value = metaData[key];
        metaDataContentItems.push({
          title: key + ':',
          value: value,
        });
      }
    }
    const metaDataContent = {
      type: 'Container',
      items: [
        {
          type: 'FactSet',
          facts: metaDataContentItems,
        },
      ],
    };
    body.push(metaDataContent);
  }
  return CardTemplate(body, msteam);
};

export function detectStage() {
  const hostname = window.location.hostname;
  if (hostname.includes('dev')) return 'dev';
  if (hostname.includes('qa')) return 'qa';
  return 'prod';
}

export async function notifyTeamsChannel(payload) {
  const card = BugReportCard(payload, 'Shopify Theme');
  const generalConfig = {
    dev: {
      url: 'https://truetale.webhook.office.com/webhookb2/f3787833-cfe2-4731-92ed-78098ccb60ae@6fd75826-b8e3-4fec-9eee-135a5cdbb580/IncomingWebhook/1b082fd4db2b4a7692c664c9d36b6808/8dbc5bc5-2d14-43c3-be1b-a06955af7765',
    },
    qa: {
      url: 'https://truetale.webhook.office.com/webhookb2/f3787833-cfe2-4731-92ed-78098ccb60ae@6fd75826-b8e3-4fec-9eee-135a5cdbb580/IncomingWebhook/fe0a6e2b20924ddf8abd9cdb701b38b1/8dbc5bc5-2d14-43c3-be1b-a06955af7765',
    },
    prod: {
      url: 'https://truetale.webhook.office.com/webhookb2/f3787833-cfe2-4731-92ed-78098ccb60ae@6fd75826-b8e3-4fec-9eee-135a5cdbb580/IncomingWebhook/22e6f5a9f286467fba1d89062e0967b8/8dbc5bc5-2d14-43c3-be1b-a06955af7765',
    },
  };
  const url = generalConfig[detectStage()]?.url;
  try {
    const response = await fetch(url || '', {
      method: 'POST',
      headers: {
        'content-type': 'text/plain',
      },
      body: card,
    });
    return response.status + ' - ' + response.statusText;
  } catch (error) {
    return error;
  }
}
